export function debugArray(label: string, value: unknown): any[] {
  if (Array.isArray(value)) {
    return value;
  }

  console.error(`[map-debug] ${label} expected array but received:`, value);
  return [];
}
